import React, { lazy } from 'react';
import ModalError from '../../components/ModalError';
import { withSuspense } from "../../utils/functions";

const ModalMessage = lazy(() => import('../../components/ModalMessage'));
const ModalAddMessage = lazy(() => import('../../components/ModalAddMessage'));
const ModalQRLink = lazy(() => import('../../components/ModalQRLink'));
const ModalSurvey = lazy(() => import('../../components/ModalSurvey'));

const ModalAppContainer = ({
  modalReducer: {
    loadedModalQRLink,
    loadedModalSurvey
  }
}) => (
  <>
    <ModalError />
    {withSuspense(<ModalMessage />)}
    {withSuspense(<ModalAddMessage />)}
    {loadedModalQRLink && withSuspense(<ModalQRLink />)}
    {loadedModalSurvey && withSuspense(<ModalSurvey />)}
  </>
);

export default React.memo(ModalAppContainer);
